<template>
    <div class="part part_about">   
      <el-row>
        <el-col :xs="24" :sm="24" class="about_center">
          <img :src="aboutImg[0].img"/>
        </el-col>
      </el-row>
    </div> 
  
  </template>
  <script>
      export default {
          name: 'About',
          data () {
              return {
                about: [
                          {
                              title: "用户协议",
                              content: ''
  
                          }
                      ],
                aboutImg:[
                  {
                    img: require('../../static/other/login.png')
                  }
                ]
              }
          }
      }
  </script>
  
  <style scoped>
    /* 公共 */
    .part{
      margin: 0;
    }
    .title{
      text-align: center;
      margin: 120px 0 50px 0;
      color: #317bcb;
    }
    .about_left{
      padding: 0% 5% 0% 5%;
    }
    .about_left ul{
      list-style: none;
      padding-left: 0;
    }
    .about_left ul li{
      text-decoration: none;
      line-height: 2em;
    }
    .about_left li img{
      margin-right: 10px;
    }
    .about_center{
      text-align: center;
      background: #4A93F6;
    }
    .about_center img{
      width: 80%;
    }
      /* 屏幕设备适配 max-device-width: 400px */
      @media screen and (max-device-width: 415px) {
        .part{
          margin: 50px 0;
        }
        .title{
          margin: 0;
        }
        .about_left{
          padding: 5% 5% 5% 5%;
        }    
        .about_right img{
          width: 90%!important;
          margin-left: 5%;
        }
      }
  </style>